import React from 'react';
import PageHero from '../../../layouts/PageHero';
import TrendingBlogs from './TrendingBlogs/TrendingBlogs';
import LatestBlogs from './LatestBlogs/LatestBlogs';
import ExploreByCity from './ExploreByCity/ExploreByCity';
import BlogAuthors from './BlogAuthors/BlogAuthors';
import ExploreByInterest from './ExploreByInterest/ExploreByInterest';
import Newsletter from '../../../layouts/Newsletter/Newsletter';
import { useMediaQuery } from '../../../hooks/mediaQuery';
import { BlogsPageProps } from '../../../pages/blog';

export interface Blog {
  imageUrl: string;
  title: string;
  date: string;
  id: string;
}

export default function RevampedBlogs({
  blogData,
  blogs,
  allBlogs,
  currentPage,
  totalPages,
  onPageChange,
  onCityChange,
  cityId
}: BlogsPageProps) {
  const isMobileOrTablet = useMediaQuery(1023);

  const latestBlogs = allBlogs
    ?.filter(blog => blog.created_at) // Ensure created_at exists
    .sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    ) // Sort by created_at
    .slice(0, 4)
    .map(blog => ({
      created_at: blog.created_at,
      image: {
        alternativeText: blog.page_title, // Use page_title as alt text
        url: blog.image // Use image URL
      },
      page_title: blog.page_title,
      publication_date: blog.publication_date,
      slug: blog.slug,
      snippet: blog.snippet
    }));
  return (
    <div className="flex flex-col gap-8 md:gap-16 mb-10">
      <div className="w-[90%] md:w-[85%] lg:w-[88%] xl:w-[85%] 2xl:w-[80%] 3xl:w-[85%] 4xl:w-[85%] mx-auto flex flex-col gap-10 md:gap-14">
        <PageHero
          title={`— ${blogData?.page_tile} —`}
          snippet={blogData?.intro_paragragh}
          media={blogData?.banner_image}
          video={false}
        />
        <div className="flex flex-row gap-6">
          <TrendingBlogs blogs={blogData?.trending} />
          {!isMobileOrTablet && <LatestBlogs blogs={latestBlogs} />}
        </div>
      </div>
      <div className="w-full bg-grayFA">
        <div className="w-[90%] md:w-[85%] lg:w-[88%] xl:w-[85%] 2xl:w-[80%] 3xl:w-[85%] 4xl:w-[85%] mx-auto flex flex-col gap-14 pt-6 md:pt-8">
          <ExploreByCity
            blogs={blogs}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            onCityChange={onCityChange}
            cities={blogData?.cities}
            cityId={cityId}
          />
        </div>
      </div>
      <div
        className="w-[90%] md:w-[85%] lg:w-[88%] xl:w-[85%] 2xl:w-[80%] 3xl:w-[85%] 4xl:w-[85%] mx-auto flex flex-col gap-14 pb-0 sm:pb-5"
        id="blogs-categories"
      >
        <ExploreByInterest
          blogs_category_images={blogData?.blog_categories as any}
        />
      </div>
      <div className="w-full bg-grayFA">
        <div className="w-[90%] md:w-[85%] lg:w-[88%] xl:w-[85%] 2xl:w-[80%] 3xl:w-[85%] 4xl:w-[85%] mx-auto flex flex-col gap-14 py-10">
          <BlogAuthors
            authors={blogData?.authors.slice().sort((a, b) => {
              return b.image ? 1 : -1;
            })}
          />
        </div>
      </div>
      <Newsletter />
    </div>
  );
}
